// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { DealerStateContext } from "@insite/client-framework/Store/Data/Dealers/DealersSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { DealerModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import AddressInfoCondensedDisplay, {
    AddressInfoCondensedDisplayStyles,
} from "@insite/content-library/Components/AddressInfoCondensedDisplay";
import DistanceDisplay, { DistanceUnitOfMeasure } from "@insite/content-library/Components/DistanceDisplay";
import GoogleMapsDirectionLink from "@insite/content-library/Components/GoogleMapsDirectionLink";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import MapPin from "@insite/mobius/Icons/MapPin";
import Phone from "@insite/mobius/Icons/Phone";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
// import parse from "html-react-parser"; // Starter Custom Code
import React, { useContext } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "@toolkit/Framework/Common/Utilities/parseFullPageHtml";
import { spacingStyles } from "@toolkit/Themes/common/mixins";

const titleProps: TypographyPresentationProps = {
    forwardAs: "h2",
    css: css`
        ${spacingStyles("1.25em", "0.25em")}
        ${({ theme }) => css`
            font-size: ${theme.design.typography.size.large};
            font-weight: ${theme.design.typography.weight.bold};
        `}
    `,
};
/* Starter Custom Code - End */

const mapStateToProps = (state: ApplicationState) => ({
    locationFinderUrl: getPageLinkByPageType(state, "LocationFinderPage")?.url,
});

type Props = ReturnType<typeof mapStateToProps> & HasHistory;

export interface DealerInformationStyles {
    container?: GridContainerProps;
    selectedDealerDisplayBackToResultsGridItem?: GridItemProps;
    selectedDealerDisplayBackToResultsLink?: LinkPresentationProps;
    nameGridItem?: GridItemProps;
    nameText?: TypographyPresentationProps;
    addressInfoGridItem?: GridItemProps;
    addressInfoIcon?: IconPresentationProps;
    addressInfoCondensed?: AddressInfoCondensedDisplayStyles;
    phoneGridItem?: GridItemProps;
    phoneLink?: LinkPresentationProps;
    distanceGridItem?: GridItemProps;
    distanceDisplayText?: TypographyPresentationProps;
    htmlContentGridItem?: GridItemProps;
    googleMapsDirectionLinkGridItem?: GridItemProps;
    googleMapsDirectionLink?: LinkPresentationProps;
    visitWebsiteLinkGridItem?: GridItemProps;
    visitWebsiteLink?: LinkPresentationProps;
    // Starter Custom Code
    wrapper?: InjectableCss;
    addressWrapper?: InjectableCss;
    contentTitle?: TypographyPresentationProps;
}

export const dealerInformationStyles: DealerInformationStyles = {
    nameText: titleProps,
    contentTitle: titleProps,
};

const styles = dealerInformationStyles;

const DealerInformation: React.FC<Props> = ({ history, locationFinderUrl }) => {
    const { value: dealer } = useContext(DealerStateContext);
    if (!dealer) {
        return null;
    }

    // Starter Removed - handleBackToResults

    /* Starter Removed - Grid - below */
    return (
        <StyledWrapper {...styles.wrapper} data-test-selector="dealerInformation" data-test-key={`${dealer.id}`}>
            {/* Starter Removed - handleBackToResults */}
            <Typography {...styles.nameText}>{translate("Location Details") /* Starter Custom Code */}</Typography>
            <StyledWrapper {...styles.addressWrapper} /* Starter Custom Code */>
                {/* Starter Removed - addressInfoIcon */}
                <AddressInfoCondensedDisplay {...dealer} extendedStyles={styles.addressInfoCondensed} />
                {dealer.phone && (
                    <Link href={`tel:${dealer.phone}`} {...styles.phoneLink} target="_blank">
                        {dealer.phone}
                    </Link>
                )}
            </StyledWrapper>
            {dealer.htmlContent && (
                <>
                    <Typography {...styles.contentTitle} /* Starter Custom Code */>{translate("Hours")}</Typography>
                    <StyledWrapper {...styles.container} data-test-selector="dealerInformation_htmlContent">
                        {parse(dealer.htmlContent, parserOptions)}
                    </StyledWrapper>
                </>
            )}
            {/* Starter Moved - googleMapsDirectionLinkGridItem - DealerDetailsHeader */}
            {/* Starter Moved - visitWebsiteLinkGridItem - DealerDetailsHeader */}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(DealerInformation)),
    definition: {
        allowedContexts: ["DealerDetailsPage"],
        group: "Dealer Details",
    },
};

export default widgetModule;
